import type { ReactNode } from 'react';

import { Icon } from '@/components/ui';
import { cx } from '@/components/ui/classNames';

/**
 * Stehender Hinweis im Formular der Administration (REQ-25 §4.5): Erklärung, Warnung oder
 * Fehler, auch mehrzeilig. Vorlage ist `AdminNotice.tsx` der ChinaApp.
 */
export interface AdminNoticeProps {
  tone?: 'info' | 'warning' | 'danger';
  children: ReactNode;
  className?: string;
}

const ICONS = {
  info: 'fa-solid fa-circle-info',
  warning: 'fa-solid fa-triangle-exclamation',
  danger: 'fa-solid fa-circle-exclamation',
} as const;

export function AdminNotice(props: AdminNoticeProps) {
  const tone = props.tone ?? 'info';

  return (
    <div
      role={tone === 'info' ? undefined : 'alert'}
      className={cx('iwm-admin-notice', `iwm-admin-notice--${tone}`, props.className)}
    >
      <Icon iconClass={ICONS[tone]} className="iwm-admin-notice-icon" />
      <div className="iwm-admin-notice-body">{props.children}</div>
    </div>
  );
}

export interface AdminWarningsProps {
  title: string;
  warnings: readonly string[];
}

/** Sammelmeldung als Liste, z. B. die Prüfbefunde unter `DefaultOrder` und `DefaultFilter`. */
export function AdminWarnings(props: AdminWarningsProps) {
  if (props.warnings.length === 0) return null;

  return (
    <AdminNotice tone="warning">
      {props.title}
      <ul className="iwm-admin-notice-list">
        {props.warnings.map((warning) => (
          <li key={warning}>{warning}</li>
        ))}
      </ul>
    </AdminNotice>
  );
}

export default AdminNotice;
